<template>
  <mm-modal
    class="active-modal"
    title="请选择激活类型"
    width="680px"
    :esc-closable="false"
    :mask-closable="false"
    :visible.sync="visible"
    :overflow-auto="true"
    @close="handleClose"
  >
    <div class="active-modal-content">
      <div class="activation-type-section">
        <div class="radio-group">
          <div class="radio-item">
            <mm-radio
              v-model="formData.activationType"
              value="new"
              class="radio-input"
            >
              新开站点
            </mm-radio>
            <div class="radio-desc">
              您将同时保留原专业版和进阶版同时运营
            </div>
          </div>
          <div class="radio-item">
            <mm-radio
              v-model="formData.activationType"
              value="upgrade"
              class="radio-input"
            >
              原站点升级
            </mm-radio>
            <div class="radio-desc">
              原专业版升级至进阶版,原专业版剩余时长将退款(装修期间专业版可正常访问)
            </div>
          </div>
        </div>
      </div>

      <div
        class="site-selection-section"
      >
        <div class="site-options">
          <mm-select
            v-model="formData.selectedSiteId"
            placeholder="请选择要升级的站点"
            class="site-select"
            :options="siteList"
            :disabled="formData.activationType !== 'upgrade'"
          />
        </div>
      </div>

      <div class="agreement-section">
        <mm-checkbox 
          v-model="formData.agreed" 
          class="checkbox-item"
        >
          我已同意《升级OKKIShops进阶版服务的特殊规则》
        </mm-checkbox>
        <mm-tooltip popper-class="upgrade-tooltip-popper">
          <span class="help-icon" />
          <div slot="content">
            <div class="upgrade-tooltip-content">
              <p>升级OKKIShops进阶版服务的特殊规则</p>
              <p>1. 升级OKKIShops进阶版服务的客户（以下简称“升级客户”）是指已经订购了OKKIShops基础版服务或OKKIShops专业版服务（以下统称“OKKIShops原服务”）的客户，在其相应的服务期限届满前，订购OKKIShops进阶版服务并在独立站建设完成后启用OKKIShops进阶版服务并终止之前的OKKIShops原服务的客户。升级客户以订购OKKIShops进阶版服务后在阿里巴巴国际站系统中选择“升级”为准。</p>
              <p>2. 升级客户订购OKKIShops进阶版服务后，小满科技提供独立站建设服务期间：</p>
              <p>（1）若OKKIShops进阶版服务下独立站店铺装修完成时，客户订购的OKKIShops原服务期限尚未届满的，客户订购OKKIShops原服务时的《建站营销软件服务销售合同》提前终止；阿里巴巴和小满科技不收取《建站营销软件服务销售合同》下通用条款第八条项下的违约金，但客户原先订购OKKIShops专业版服务且激活的，阿里巴巴国际站或小满科技仍有权向客户收取制作费人民币伍仟元整（¥5,000）。阿里巴巴国际站或小满科技在扣除制作费及相应的服务费后，在确认客户处理完毕发票等事宜后，将OKKIShops原服务剩余的订单金额退还给客户。退款事项处理完毕后，OKKIShops原服务终止。</p>
              <p>（2）若OKKIShops进阶版服务下独立站店铺装修完成前，客户订购的OKKIShops原服务期限已届满，则小满科技免费将OKKIShops原服务期限延长120个自然日，若因小满科技的原因导致独立站店铺无法在120个自然日内完成装修的，将再免费延长，最长延长期限为一年。在延长的服务期限内，客户理解并同意，小满科技仅提供OKKIShops基础版服务。</p>
              <p>3. 客户理解并同意，OKKIShops原服务升级到OKKIShops进阶版服务后，将不能再降级至OKKIShops原服务。</p>
            </div>
          </div>
        </mm-tooltip>
      </div>

      <div class="submit-section">
        <mm-button
          type="primary"
          :disabled="!isFormValid"
          :loading="loading"
          @click="handleSubmit"
        >
          提交
        </mm-button>
      </div>
    </div>
  </mm-modal>
</template>

<script>
import OrderApi from "@api/order";
import { Tooltip } from "amumu-ui";

export default {
  name: "ActivateModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    "mm-tooltip": Tooltip,
  },
  data() {
    return {
      formData: {
        activationType: "",
        selectedSiteId: "",
        agreed: false,
      },
      siteList: [],
    };
  },
  computed: {
    isFormValid() {
      if (!this.formData.activationType) {
        return {
          isError: true,
          msg: "请选择激活类型",
        };
      }
      if (
        this.formData.activationType === "upgrade" &&
        !this.formData.selectedSiteId
      ) {
        return {
          isError: true,
          msg: "请选择要升级的站点",
        };
      }
      if (!this.formData.agreed) {
        return {
          isError: true,
          msg: "请同意《升级OKKIShops进阶版服务的特殊规则》",
        };
      }
      return {
        isError: false,
        msg: "",
      };
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.getUpgradableSites();
      }
      if (!newVal) {
        this.resetForm();
      }
    },
  },
  methods: {
    handleClose() {
      this.resetForm();
      this.$emit("close");
    },
    async getUpgradableSites() {
      const data = await OrderApi.getUpgradableSites()
      this.siteList = data.map((item) => {
        return {
          label: item.business_name,
          value: item.business_id,
        }
      })
    },
    // 提交表单
    handleSubmit() {
      if (this.isFormValid.isError) {
        this.$message.warning(this.isFormValid.msg);
        return;
      }

      this.$emit("submit", {
        businessId: this.formData.selectedSiteId,
        activationType: this.formData.activationType,
      });
    },
    // 重置表单
    resetForm() {
      this.formData = {
        activationType: "",
        selectedSiteId: "",
        agreed: false,
      };
    },
  },
};
</script>

<style scoped>
.active-modal-content {
  padding: 20px;
}

.section-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 16px;
}

.site-selection-section {
  margin-top: 12px;
  padding-left: 24px;
}

.radio-group,
.site-options {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.site-select {
  width: 240px;
}

.radio-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

:deep(.mm-radio-faux) {
  display: flex;
  align-items: center;
}

:deep(.mm-radio .mm-radio-faux .mm-radio-label) {
  margin-left: 12px;
  padding: 2px 6px;
  border: 1px solid #1890ff;
  border-radius: 4px;
  color: #1890ff;
}

.radio-desc {
  font-size: 12px;
}

.agreement-section {
  display: flex;
  align-items: center;
  margin: 24px;
}

.checkbox-item {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.submit-section {
  text-align: right;
}

:global(.upgrade-tooltip-popper) {
  max-width: none !important;
  width: 550px !important;
  max-height: 350px !important;
  overflow-y: auto !important;
}
:deep(.mm-tooltip) {
  font-size: 16px;
  color: #5d5d5d;
}
:deep(.upgrade-tooltip-content p) {
  margin-bottom: 3px;
}
.help-icon {
  width: 16px;
  height: 16px;
  background-size: 16px;
}
</style>
